import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventPromotion {
	mstLink: string;
	mstNm: string;
}

const key = "useEventPromotion";
/** ```
 * 행사 관련기획전 리스트 조회
 *   `/event/{evCd}/promotion`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const getPath = (evCd: string): string | null =>
	`${publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH}/api/event/${evCd}/promotion`;

/** ```
 * 행사 관련기획전 리스트 조회
 *   `/event/{evCd}/promotion`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventPromotion = (evCd: string, options?: Partial<UseQueryOptions<Response<EventPromotion[]>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useEventPromotion;
export {getPath, key};
export type {EventPromotion};
